var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { defineComponent, isRef } from "vue";
import template$1 from "../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/template.js";
const cc = /* @__PURE__ */ __name(() => "", "cc"), SmartRenderer = defineComponent({
  name: "SmartRenderer",
  props: {
    children: null
  },
  render({ children }) {
    return isRef(children) ? children.value : children;
  }
});
function styleNumberValueWithUnit(x) {
  return typeof x == "number" || /^-?\d+(?:\.\d+)?$/.test(x) ? `${x}px` : x;
}
__name(styleNumberValueWithUnit, "styleNumberValueWithUnit");
function vnodeBindingVModel(props) {
  if (!props)
    return !1;
  const keys = Object.keys(props);
  return keys.includes("modelValue") && keys.includes("onUpdate:modelValue");
}
__name(vnodeBindingVModel, "vnodeBindingVModel");
function resolveVNode(v) {
  return typeof v == "function" ? v() : v;
}
__name(resolveVNode, "resolveVNode");
function template(tmp) {
  return template$1(tmp, { interpolate: /\{{2}([\s\S]+?)\}{2}/g });
}
__name(template, "template");
export {
  SmartRenderer,
  cc,
  resolveVNode,
  styleNumberValueWithUnit,
  template,
  vnodeBindingVModel
};
//# sourceMappingURL=utils.js.map
